const running = state => state.running
const processes = state => state.processes

export default {
  running,
  processes
}
